(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-reviews-editorial"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('jj-customer-reviews')) customElements.define('jj-customer-reviews',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;this.abort=new AbortController();const signal=this.abort.signal;
  this.track=this.querySelector('.jj-reviews__track');this.controls=this.querySelector('.jj-reviews__controls');this.labels=JSON.parse(this.querySelector('[data-labels]').textContent);this.motion=matchMedia('(prefers-reduced-motion: reduce)');
  let data;try{data=JSON.parse(this.querySelector('[data-reviews]').textContent);if(typeof data==='string')data=JSON.parse(data);}catch{return;}
  const reviews=(data?.all_reviews?.reviews||[]).filter(r=>r.body&&r.reviewer_name&&Number(r.rating)>=1&&Number(r.rating)<=5);
  if(!reviews.length)return;
  const meaningful=reviews.filter(r=>r.body.length>60).sort((a,b)=>Number(b.rating)-Number(a.rating)||Math.min(b.body.length,450)-Math.min(a.body.length,450));
  const featured=meaningful[0];if(this.dataset.featured==='true'&&featured){const area=this.querySelector('.jj-reviews__featured');area.append(this.card(featured));area.hidden=false;}
  const selected=[...meaningful,...reviews].filter((r,i,a)=>a.findIndex(x=>x.uuid===r.uuid)===i).filter(r=>!(this.dataset.featured==='true'&&r===featured)).slice(0,12);
  selected.forEach((r,i)=>{const card=this.card(r);card.style.setProperty('--jr-delay',`${Math.min(i,2)*70}ms`);this.track.append(card);});
  this.prev=this.querySelector('[data-prev]');this.next=this.querySelector('[data-next]');this.dots=this.querySelector('.jj-reviews__dots');this.pause=this.querySelector('[data-pause]');
  this.prev.addEventListener('click',()=>{this.stop();this.move(-1,true);},{signal});this.next.addEventListener('click',()=>{this.stop();this.move(1,true);},{signal});
  this.track.addEventListener('keydown',e=>{if(e.target!==this.track)return;if(['ArrowLeft','ArrowRight','Home','End'].includes(e.key)){e.preventDefault();this.stop();if(e.key==='Home'||e.key==='End')this.go(e.key==='Home'?0:this.pages.length-1,true);else this.move(e.key==='ArrowLeft'?-1:1,true);}},{signal});
  this.track.addEventListener('scroll',()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.update());},{signal,passive:true});
  this.addEventListener('pointerdown',e=>{if(e.target!==this.pause)this.stop();},{signal,passive:true});this.addEventListener('focusin',()=>this.stop(),{signal});this.addEventListener('mouseenter',()=>this.clear(),{signal});this.addEventListener('mouseleave',()=>this.start(),{signal});
  this.pause.addEventListener('click',()=>{this.stopped=!this.stopped;this.pause.textContent=this.stopped?this.labels.resume:this.labels.pause;this.stopped?this.clear():this.start();},{signal});
  this.resize=new ResizeObserver(()=>this.layout());this.resize.observe(this.track);this.layout();
  this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;if(this.visible){this.classList.add('is-visible');this.start();}else this.clear();},{threshold:.1});this.observer.observe(this);
  document.addEventListener('visibilitychange',()=>document.hidden?this.clear():this.start(),{signal});this.motion.addEventListener('change',()=>this.motion.matches?this.clear():this.start(),{signal});
 }
 card(r){
  const c=document.createElement('article');c.className='jj-reviews__card';const stars=document.createElement('div');stars.className='jj-reviews__stars';stars.textContent='★'.repeat(Number(r.rating))+'☆'.repeat(5-Number(r.rating));stars.setAttribute('role','img');stars.setAttribute('aria-label',this.labels.rating.replace('[rating]',r.rating));c.append(stars);
  const quote=document.createElement('blockquote');quote.textContent=r.body;c.append(quote);
  if(r.body.length>260){quote.classList.add('is-short');const more=document.createElement('button');more.type='button';more.className='jj-reviews__more';more.textContent=this.labels.more;more.setAttribute('aria-expanded','false');more.addEventListener('click',()=>{const short=quote.classList.toggle('is-short');more.textContent=short?this.labels.more:this.labels.less;more.setAttribute('aria-expanded',String(!short));});c.append(more);}
  const author=document.createElement('p');author.className='jj-reviews__author';author.textContent=r.reviewer_name;c.append(author);
  if(this.dataset.products==='true'&&r.product_title){let url;try{url=new URL(r.product_url,location.origin);}catch{}const good=r.product_in_store!==false&&r.product_url&&url?.origin===location.origin&&url.pathname.startsWith('/products/');const product=document.createElement(good?'a':'span');product.className='jj-reviews__product';product.textContent=r.product_title;if(good)product.href=url.pathname+url.search;c.append(product);}
  if(this.dataset.verified==='true'&&r.verified_buyer===true){const verified=document.createElement('span');verified.className='jj-reviews__verified';verified.textContent='✓ '+this.labels.verified;c.append(verified);}return c;
 }
 layout(){const cards=[...this.track.children];if(!cards.length)return;const width=this.track.clientWidth;const step=cards[1]?cards[1].offsetLeft-cards[0].offsetLeft:width;const visible=Math.max(1,Math.round((width+28)/step));this.pages=[];for(let i=0;i<cards.length;i+=visible)this.pages.push(Math.min(i*step,this.track.scrollWidth-width));this.pages=[...new Set(this.pages)];this.dots.replaceChildren();this.pages.forEach((_,i)=>{const dot=document.createElement('button');dot.type='button';dot.setAttribute('aria-label',this.labels.go.replace('[index]',i+1));dot.addEventListener('click',()=>{this.stop();this.go(i,true);});this.dots.append(dot);});this.controls.hidden=this.pages.length<2;this.pause.hidden=this.dataset.autoplay!=='true'||this.motion.matches;this.update();}
 update(){this.index=this.pages.reduce((best,p,i)=>Math.abs(p-this.track.scrollLeft)<Math.abs(this.pages[best]-this.track.scrollLeft)?i:best,0);this.prev.disabled=this.index===0;this.next.disabled=this.index===this.pages.length-1;[...this.dots.children].forEach((d,i)=>d.setAttribute('aria-current',String(i===this.index)));}
 go(i,announce=false){i=Math.max(0,Math.min(i,this.pages.length-1));this.track.scrollTo({left:this.pages[i],behavior:this.motion.matches?'instant':'smooth'});if(announce)this.querySelector('.jj-reviews__status').textContent=this.labels.go.replace('[index]',i+1);}
 move(direction,announce){this.go(this.index+direction,announce);}
 clear(){clearInterval(this.timer);this.timer=null;}
 stop(){this.stopped=true;this.clear();if(this.pause)this.pause.textContent=this.labels.resume;}
 start(){this.clear();if(this.dataset.autoplay==='true'&&!this.stopped&&this.visible&&!document.hidden&&!this.motion.matches&&!this.matches(':hover')&&!this.contains(document.activeElement)&&this.pages?.length>1&&!window.Shopify?.designMode)this.timer=setInterval(()=>this.go((this.index+1)%this.pages.length),Math.max(8,Number(this.dataset.speed))*1000);}
 disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();this.observer?.disconnect();this.clear();cancelAnimationFrame(this.frame);this.ready=false;this.track?.replaceChildren();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mission-page-story"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('jj-mission-page'))customElements.define('jj-mission-page',class extends HTMLElement{connectedCallback(){if(!('IntersectionObserver' in window)||matchMedia('(prefers-reduced-motion: reduce)').matches||window.Shopify?.designMode)return;this.observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-visible');this.observer.unobserve(e.target);}}),{threshold:.08});this.querySelectorAll('.jj-purpose__reveal').forEach(e=>this.observer.observe(e));}disconnectedCallback(){this.observer?.disconnect();}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-mission-collage"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jj-mission-controller')) {
  class JJMissionController extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('.shopify-section')?.querySelector('.jj-mission');
      if (!this.root || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches || window.Shopify?.designMode) return;
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.root.classList.remove('is-pending', 'is-offscreen');
            this.root.classList.add('is-visible');
          } else if (this.root.classList.contains('is-visible')) {
            this.root.classList.add('is-offscreen');
          }
        });
      }, {threshold: 0, rootMargin: '0px 0px -40px 0px'});
      this.root.classList.add('is-pending');
      this.observer.observe(this.root);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  }
  customElements.define('jj-mission-controller', JJMissionController);
}

  } catch(e) { console.error(e); }
})();
})();
